import { getEditorPlugin,type SlateEditor } from '@udecode/plate';

import { updateCitation } from '../../lib';
import { CitationPlugin } from '../CitationPlugin';

/**
 * Insert link if url is valid. Text is url if empty. Close floating link. Focus
 * editor.
 */
export const submitFloatingCitation = (editor: SlateEditor) => {
    if (!editor.selection) {
        return;
    }

    const { api, getOptions } = getEditorPlugin(editor, CitationPlugin);

    const {
        pageNumber,
    } = getOptions();

    api.floatingCitation.hide();

    updateCitation(editor, {
        pageNumber
    });

    setTimeout(() => {
        editor.tf.focus({ at: editor.selection! });
    }, 0);

    return true;
};
